import { createMuiTheme } from '@material-ui/core/styles';

// TODO: export SCSS variables for colors, import them here, and use in theme
/*
  Check the below link for complete list of configurable theme properties
  https://v4.mui.com/customization/default-theme/

  Check the following link for themeing examples
  https://v4.mui.com/customization/palette/
*/
const borderColorClass = 'rgba(57, 63, 82, 0.16)';
const boxShadowClass = '0px 11.5338px 11.5338px rgba(228, 0, 43, 0.1)';
const globalTheme = createMuiTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 375,
      md: 768,
      lg: 1024,
      xl: 1440,
    },
  },
  palette: {
    primary: {
      // light: will be calculated from palette.primary.main,
      main: '#EE3A43',
      // dark: will be calculated from palette.primary.main,
      contrastText: '#FFFFFF',
    },
    secondary: {
      // light: will be calculated from palette.secondary.main,
      main: '#FFFFFF',
      // dark: will be calculated from palette.secondary.main,
      contrastText: '#393F52',
    },
    disabledContained: {
      // light: will be calculated from palette.secondary.main,
      main: '#A9BDD0',
      // dark: will be calculated from palette.secondary.main,
      contrastText: '#FFFFFF',
    },
    disabledOutlined: {
      // light: will be calculated from palette.secondary.main,
      main: '#A9BDD0',
      // dark: will be calculated from palette.secondary.main,
      contrastText: '#FFFFFF',
    },
    // error: {} // will use the default color
    // warning: {} // will use the default color
    // info: {} // will use the default color
    // success: {} // will use the default color
  },
  typography: {
    // htmlFontSize: 10,
    fontFamily: ['Rubik', 'Roboto', 'sans-serif'].join(','),
  },
  shape: {
    borderRadius: 4,
    '@media (min-width:1024px)': {
      borderRadius: 10,
    },
  },
});

const theme = createMuiTheme(
  {
    overrides: {
      MuiButton: {
        root: {
          // This is the medium size.
          fontSize: '1.1rem',
          fontWeight: '700',
          '@media (min-width:1024px)': {
            fontSize: '1.2rem',
          },
        },
        sizeSmall: {
          fontSize: '.9rem',
        },
        sizeLarge: {
          fontSize: '1.6rem',
        },
        contained: {
          '&:disabled, &:disabled:hover': {
            backgroundColor: globalTheme.palette.disabledContained.main,
            color: globalTheme.palette.disabledContained.contrastText,
            boxShadow: 'none',
          },
        },
        containedPrimary: {
          // boxShadow: '0 0.6rem 1rem rgba(222, 0, 0, 0.2);',
          // '&:hover': {
          //   boxShadow: '0 1rem 1rem rgba(222, 0, 0, 0.25);',
          // },
          boxShadow: 'none',
          '&:hover': {
            boxShadow: 'none',
          }
        },
        containedSecondary: {
          boxShadow: 'none',
          borderColor: 'rgba(57, 63, 82, 0.16)',
          color: globalTheme.palette.secondary.contrastText,
          '&:hover': {
            boxShadow: '0 1rem 1rem rgba(0, 0, 0, 0.1);',
            borderColor: { borderColorClass },
            color: globalTheme.palette.secondary.contrastText,
          },
        },
        outlined: {
          '&:disabled, &:disabled:hover': {
            color: globalTheme.palette.disabledOutlined.main,
            backgroundColor: globalTheme.palette.disabledOutlined.contrastText,
            boxShadow: 'none',
          },
        },
        outlinedPrimary: {
          borderWidth: '.2rem',
          color: globalTheme.palette.primary.contrastText,
          borderColor: globalTheme.palette.primary.main,
          backgroundColor: globalTheme.palette.primary.main,
          boxShadow: { boxShadowClass },
          '&:hover': {
            borderWidth: '.2rem',
            color: globalTheme.palette.primary.main,
            backgroundColor: globalTheme.palette.primary.contrastText,
            boxShadow: { boxShadowClass },
          },
          '@media (hover: none)': {
            '&:hover,&:active, &:focus': {
              borderWidth: '.2rem',
              backgroundColor: `${globalTheme.palette.primary.contrastText} !important`,
              color: globalTheme.palette.primary.main,
              boxShadow: { boxShadowClass },
            },
          },
        },
        outlinedInfo: {
          borderWidth: '.2rem',
          color: globalTheme.palette.primary.main,
          borderColor: globalTheme.palette.primary.contrastText,
          backgroundColor: globalTheme.palette.primary.contrastText,
          boxShadow: { boxShadowClass },
          '&:hover': {
            borderWidth: '.2rem',
            color: globalTheme.palette.primary.contrastText,
            backgroundColor: globalTheme.palette.primary.main,
            boxShadow: { boxShadowClass },
          },
          '@media (hover: none)': {
            '&:hover,&:active, &:focus': {
              borderWidth: '.2rem',
              backgroundColor: `${globalTheme.palette.primary.main} !important`,
              color: globalTheme.palette.primary.contrastText,
              boxShadow: { boxShadowClass },
            },
          },
        },
        outlinedSuccess: {
          borderWidth: '.2rem',
          color: globalTheme.palette.primary.main,
          borderColor: globalTheme.palette.primary.contrastText,
          backgroundColor: globalTheme.palette.primary.contrastText,
          boxShadow: { boxShadowClass },
          '&:hover': {
            borderWidth: '.2rem',
            color: globalTheme.palette.primary.main,
            backgroundColor: globalTheme.palette.primary.contrastText,
            boxShadow: { boxShadowClass },
          },
          '@media (hover: none)': {
            '&:hover,&:active, &:focus': {
              borderWidth: '.2rem',
              backgroundColor: `${globalTheme.palette.primary.contrastText} !important`,
              color: globalTheme.palette.primary.main,
              boxShadow: { boxShadowClass },
            },
          },
        },
        outlinedSecondary: {
          borderWidth: '.2rem',
          color: globalTheme.palette.primary.main,
          borderColor: globalTheme.palette.primary.contrastText,
          backgroundColor: globalTheme.palette.primary.contrastText,
          boxShadow: { boxShadowClass },
          '&:hover': {
            borderWidth: '.2rem',
            color: globalTheme.palette.primary.contrastText,
            backgroundColor: globalTheme.palette.primary.main,
            boxShadow: { boxShadowClass },
          },
          '@media (hover: none)': {
            '&:hover,&:active, &:focus': {
              borderWidth: '.2rem',
              backgroundColor: `${globalTheme.palette.primary.main} !important`,
              color: globalTheme.palette.primary.contrastText,
              boxShadow: { boxShadowClass },
            },
          },
        },
      },
      MuiToolbar: {
        regular: {
          backgroundColor: '#ffffff',
          color: '#000000',
          fontSize: '1.3rem',
        },
      },
      MuiDrawer: {
        paper: {
          overflowY: 'visible',
        },
      },
      MuiRadio: {
        root: {
          '& .MuiSvgIcon-root': {
            fontSize: '2rem',
          },
        },
        colorSecondary: {
          '&$checked': {
            color: globalTheme.palette.primary.main,
          },
        },
      },
      MuiCheckbox: {
        root: {
          '& .MuiSvgIcon-root': {
            fontSize: '2rem',
          },
        },
        colorSecondary: {
          '&$checked': {
            color: globalTheme.palette.primary.main,
          },
        },
      },
      MuiTextField: {
        root: {
          '& label, & input': {
            fontSize: '1.3rem',
            fontWeight: 'bold',
          },
        },
      },
      MuiPaper: {
        root: {
          boxShadow: '0px 2.17631px 7.61708px rgba(155, 204, 244, 0.241231) !important;',
        },
      },
      MuiDialogContent: {
        root: {
          padding: `0 !important`,
        },
      },
    },
  },
  globalTheme
);
export default theme;
